import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createMenuItem } from '../../helpers/api_helper';

const useCreateMenuItem = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const createMenuItemHook = async (data) => {
        setLoading(true);
        setError(null);
        try {
            console.log(`tenantid en hook: ${tenantId}`);
            const response = await createMenuItem(tenantId, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to create menu item: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { createMenuItem: createMenuItemHook, loading, error };
};

export default useCreateMenuItem;